import validation from '../../../../../../modules/Gull/Framework/validation.js';

const stap1 = {

	init() {

		// Focus op eerste veld van formulier
		$('input:enabled:visible:first').focus();

		// Start het ophalen van de KvK gegevens
		stap1.getKvK(1);

		// Draai getKvK functie als kvk veld verlaten wordt
		$('form[data-validate] input#NR_KVK').blur(stap1.getKvK);

		// Maak correspondentiegegevens velden enabled als geladen gegevens niet correct zijn
		$('select#nawCorrect').on('change', function() {
			if (typeof this.value !== 'undefined' && this.value == 'nee') {
				$('.kvk_data').prop('disabled', false);
				$('#nawCorrectUitleg').prop('disabled', false).closest('.form-group').removeClass('d-none');
				validation.addRequired($('#nawCorrectUitleg'));
				// $('#NM_RELATIE').prop('disabled', true);
			} else {
				$('.kvk_data').prop('disabled', true);
				$('#nawCorrectUitleg').prop('disabled', true).closest('.form-group').removeClass('d-none').addClass('d-none');
				validation.removeRequired($('#nawCorrectUitleg'));
			}
		});

	},

	// Functie om op basis van KvK nummer bedrijfsgegevens op te halen bij KvK
	getKvK: function(start) {
		start = typeof start !== 'undefined' ? start : 0;
		if (start != 1) {
			start = 0;
		}
		var NR_KVK = $('#NR_KVK').val();
		if (NR_KVK.length == 8) {

			// Toon het laden spinner
			$('.kvk-spinner').removeClass('d-none').removeClass('d-none');

			$.getJSON(document.URL + '/getRelatieThroughKvK/' + NR_KVK + '/', function(data) {
				var fields = ['SBIKODE', 'SBIKODE2', 'SBIKODE3', 'KD_SECTOR', 'CAO', 'KOR_ADR', 'KOR_ADRNR', 'KOR_ADRTOEV', 'POSTKD', 'WOONPL', 'KD_LAND', 'nawCorrect', 'nawCorrectUitleg'];

				$.each(fields, function(index, fieldname) {
					var value = '';
					if (data != false && (typeof data.values[fieldname] !== 'undefined')) {
						value = data.values[fieldname];
					}

					if ('CAO' === fieldname) {
						if (value === undefined || '' === value) {
							value = 'n_v_t';
						}
					}
					if ('nawCorrect' === fieldname) {
						if ('nee' === value) {
							value = 'nee';
						} else {
							value = 'ja';
						}
					}
					if ('KD_LAND' === fieldname) {
						if (value == 'NLD') {
							value = 'NL';
						} else if (value == 'DEU') {
							value = 'DE';
						} else if (value == 'BEL') {
							value = 'BE';
						} else if (value == 'GBR') {
							value = 'GB';
						} else if (value == 'POL') {
							value = 'PL';
						} else if (value == 'FRA') {
							value = 'FR';
						} else if (value == 'LUX') {
							value = 'LU';
						} else if (value == 'DNK') {
							value = 'DK';
						} else if (value == 'USA') {
							value = 'US';
						}
					}

					// Maak de SBIKODE velden zichtbaar als ze missen in de KvK data
					if ((fieldname == 'SBIKODE') || (fieldname == 'SBIKODE2') || (fieldname == 'SBIKODE3')) {
						if (value === '') {
							// $('#' + fieldname).closest('.form-group').removeClass('d-none').removeClass('d-none');
						} else {
							// $('#' + fieldname).closest('.form-group').addClass('d-none');
						}
					}

					$('#' + fieldname).val(value).trigger('blur');
				});

				var NM_RELATIE = '';
				if (data != false && (typeof data.base['NM_RELATIE'] !== 'undefined')) {
					NM_RELATIE = data.base['NM_RELATIE'];
					// NM_RELATIE = heTool.decode(NM_RELATIE);
					NM_RELATIE = stap1.decodeHtmlEntities(NM_RELATIE);
					$('#NM_RELATIE').val(NM_RELATIE).trigger('blur');
				}
				if (data != false) {
					$('.select2-general').trigger('change');
					stap1.toggleFields(1);
					// $('#NM_RELATIE,#KOR_ADR,#KOR_ADRNR,#POSTKD,#WOONPL,#KD_LAND,#SBIKODE').attr('data-validate', '');
					if ('' == NM_RELATIE) {
						$('#modal_kvk_Warning').modal('show');

						stap1.toggleFields(0);
						// $('#NM_RELATIE,#KOR_ADR,#KOR_ADRNR,#POSTKD,#WOONPL,#KD_LAND,#SBIKODE').attr('data-validate', 'required');
					}
				} else {
					if (start == 0) {
						$('#modal_kvk_Warning').modal('show');

						stap1.toggleFields(0);
						// $('#NM_RELATIE,#KOR_ADR,#KOR_ADRNR,#POSTKD,#WOONPL,#KD_LAND,#SBIKODE').attr('data-validate', 'required');
					} else {
						$('#NR_KVK').focus();
					}
				}
				$('#nawCorrect').trigger('change');

				// Verberg het laden spinner
				$('.kvk-spinner').addClass('d-none').addClass('d-none');
			});
		}
	},

	// Functie om SBI velden te tonen en te verbergen
	toggleFields: function(goed) {
		goed = typeof goed !== 'undefined' ? goed : 0;
		if (goed == 1) {
			// $('form[data-validate] input#SBIKODE, form[data-validate] input#SBIKODE2, form[data-validate] input#SBIKODE3 ').closest('.form-group').addClass('d-none');
			$('#NoKvK').addClass('d-none').addClass('d-none');
			$('.kvk_data').prop('disabled', true);
			$('.kvk-form-field').removeClass('d-none').removeClass('d-none');
			if ($('form[data-validate] input#SBIKODE').val() == '') {
				// $('form[data-validate] input#SBIKODE, form[data-validate] input#SBIKODE2, form[data-validate] input#SBIKODE3 ').closest('.form-group').removeClass('d-none');
				$('.kvk_data').prop('disabled', false);
			}
		} else {
			// $('form[data-validate] input#SBIKODE, form[data-validate] input#SBIKODE2, form[data-validate] input#SBIKODE3 ').closest('.form-group').removeClass('d-none');
			$('form[data-validate] input#NR_KVK').css('background-color', '#EEE');
			$('form[data-validate] input#SBIKODE').focus();
			$('.kvk_data').prop('disabled', false);
			$('#NoKvK').addClass('d-none').addClass('d-none');
			$('.kvk-form-field').removeClass('d-none').removeClass('d-none');
		}
	},

	decodeHtmlEntities: function(html) {
		var txt = document.createElement('textarea');
		txt.innerHTML = html;
		return txt.value;
	}

};

export default stap1;
